'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Responsive Image Component.
 * @param {Object} props The new component properties.
 * @returns {ReactElement} HTML markup for the component
 */
var ResponsiveImage = function ResponsiveImage(_ref) {
    var source = _ref.source,
        sourceDefinitions = _ref.sourceDefinitions,
        altText = _ref.altText,
        className = _ref.className,
        id = _ref.id;
    return (0, _jsx3.default)('picture', {
        id: id,
        className: className
    }, void 0, sourceDefinitions.map(function (definition) {
        return (0, _jsx3.default)('source', {
            srcSet: definition.source,
            media: definition.media
        }, definition.source);
    }), (0, _jsx3.default)('img', {
        src: source,
        alt: altText
    }));
};

exports.default = ResponsiveImage;
//# sourceMappingURL=ResponsiveImage.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/responsiveImage/ResponsiveImage.js
// module id = 596
// module chunks = 0